import type { ReactNode } from "react";
import { tv } from "tailwind-variants";

interface MobileStickyMenuItemProps {
  icon: ReactNode;
  title: string;
  isHiddenOnDesktop?: boolean;
  className?: string;
}

export function MobileStickyMenuItem({ icon, title, isHiddenOnDesktop, className }: MobileStickyMenuItemProps) {
  return (
    <div
      className={tv({
        base: ["max-xl:flex max-xl:w-full max-xl:flex-col max-xl:items-center max-xl:py-2.5"],
        variants: {
          isHiddenOnDesktop: { true: ["xl:hidden"] },
        },
      })({ isHiddenOnDesktop, className })}
    >
      <div className="max-lg:mb-0.5 max-lg:flex max-lg:items-end max-lg:justify-center max-xl:size-6">{icon}</div>
      <span className="text-xs xl:hidden">{title}</span>
    </div>
  );
}
